import { render } from "./dealer_list.vue?vue&type=template&id=c8f38c64"
import script from "./dealer_list.vue?vue&type=script&lang=js"
export * from "./dealer_list.vue?vue&type=script&lang=js"

import "./dealer_list.vue?vue&type=style&index=0&id=c8f38c64&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__